<div class="personal-data-container component-container connection-address-container">
  <form
    [formGroup]="connectionAddressFG"
    *ngIf="connectionAddressFG"
    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
    <div *ngIf="connectionAddressFG.get('buildingType')" class="ui-g form-rows">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align" [class.required]="isFieldRequired('buildingType')" or="building-type">
          {{ 'personal-data.form-details.fields.building-type' | translate }}
        </label>
        <p-dropdown
          [options]="buildingTypes"
          [readonly]="isReadOnly"
          formControlName="buildingType"
          id="building-type"
          placeholder="-Select-">
          <ng-template let-item pTemplate="selectedItem">
            <span class="drop-item-label">{{ 'lookup.' + buildingTypeKey + '.options.' + item['value'] + '.name' | translate }}</span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="drop-item">
              <span class="drop-item-label">{{ 'lookup.' + buildingTypeKey + '.options.' + option['value'] + '.name' | translate }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>

    <ng-container *ngIf="!isParcelAddress">
      <div class="ui-g form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align" [ngClass]="{ required: areAddressFieldsMandatory }" for="address-postcode">
            {{ 'personal-data.form-details.fields.post-code' | translate }}
          </label>
          <input
            [appNumber]="true"
            class="ui-input pInputText"
            formControlName="postCode"
            id="address-postcode"
            pInputText
            size="30"
            [readonly]="isReadOnly" />
        </div>

        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label class="ui-g-5 field-label text-right-align" [ngClass]="{ required: areAddressFieldsMandatory }" for="address-city-ort">
            {{ 'personal-data.form-details.fields.city-ort' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            formControlName="city"
            id="address-city-ort"
            maxlength="100"
            pInputText
            size="30"
            type="text"
            [readonly]="isReadOnly" />
        </div>
      </div>

      <div class="ui-g form-rows" *ngIf="connectionAddressFG.get('district')">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows"></div>
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align" for="address-district">
            {{ 'personal-data.form-details.fields.district' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            formControlName="district"
            id="address-district"
            maxlength="50"
            pInputText
            size="30"
            type="text"
            [readonly]="isReadOnly" />
        </div>
      </div>

      <div class="ui-g form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align" [ngClass]="{ required: areAddressFieldsMandatory }" for="address-street">
            {{ 'personal-data.form-details.fields.street' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            formControlName="street"
            id="address-street"
            maxlength="30"
            pInputText
            size="30"
            appAlpha="true"
            [readonly]="isReadOnly" />
        </div>

        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label class="ui-g-5 field-label text-right-align" [ngClass]="{ required: areAddressFieldsMandatory }" for="address-street-no">
            {{ 'personal-data.form-details.fields.street-number' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            formControlName="streetNo"
            id="address-street-no"
            maxlength="10"
            pInputText
            size="30"
            [attr.appStreetNumber]="true"
            [readonly]="isReadOnly" />
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isParcelAddress">
      <div class="ui-g form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required" for="sws-subdistrict">
            {{ 'basic-profile.jurisdiction.sws-subdistrict' | translate }}
          </label>
          <input
            appAlpha="true"
            class="ui-input pInputText"
            formControlName="swsDevAreaSubDistrict"
            id="sws-subdistrict"
            pInputText
            size="30"
            [readonly]="isReadOnly" />
        </div>

        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label class="ui-g-5 field-label text-right-align required" for="sws-parcel">
            {{ 'basic-profile.jurisdiction.sws-parcel' | translate }}
          </label>
          <input
            [appNumber]="true"
            class="ui-input pInputText"
            formControlName="swsParcel"
            id="sws-parcel"
            pInputText
            size="30"
            [readonly]="isReadOnly" />
        </div>
      </div>

      <div class="ui-g form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required" for="sws-parcel-no">
            {{ 'basic-profile.jurisdiction.sws-parcel-no' | translate }}
          </label>
          <input
            appStreetNumber="true"
            class="ui-input pInputText"
            formControlName="swsParcelNumber"
            id="sws-parcel-no"
            pInputText
            size="30"
            [readonly]="isReadOnly" />
        </div>

        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label class="ui-g-5 field-label text-right-align" for="sws-dev-area-name">
            {{ 'basic-profile.jurisdiction.sws-development-area-name' | translate }}
          </label>
          <input
            appAlpha="true"
            class="ui-input pInputText"
            formControlName="swsDevAreaName"
            id="sws-dev-area-name"
            pInputText
            size="30"
            [readonly]="isReadOnly" />
        </div>
      </div>
    </ng-container>

    <app-custom-fields
      formControlName="customFields"
      [applicationSection]="applicationSection"
      [isReadOnly]="isReadOnly"></app-custom-fields>
  </form>
</div>
